module.exports = __webpack_public_path__ + "static/media/logo.3777f81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/logo.png
// module id = 393
// module chunks = 0